import { render } from "./RefundGoods.vue?vue&type=template&id=2c65d8c4"
import script from "./RefundGoods.vue?vue&type=script&lang=js"
export * from "./RefundGoods.vue?vue&type=script&lang=js"

import "./RefundGoods.vue?vue&type=style&index=0&id=2c65d8c4&lang=scss"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__